import React, { useEffect } from 'react';
import { ExpediteDeliveryCard } from '@shopee/chatbot-ui';
import { dispatchTrack } from '@/utils/tracking';
import {
  TRACKING_OPERATION,
  TRACKING_PAGE,
  TRACKING_SECTION,
  TRACKING_TARGET,
} from '@/utils/constants';
import { ChatbotUIBasicProps } from '@/types/common';
import './style.scss';

export type DeliveryInstructionCardProps = {
  title: string;
  subTitle: string;
  instructions: string;
  trackingData: any;
} & ChatbotUIBasicProps;

const DeliveryInstructionCard: React.FC<DeliveryInstructionCardProps> = (
  props,
) => {
  const { title, subTitle, instructions, trackingData } = props;

  const trackingParams = {
    page: TRACKING_PAGE.MAIN_PAGE,
    operation: TRACKING_OPERATION.IMPRESSION,
    target: TRACKING_TARGET.deliveryInstructionCard,
    section: TRACKING_SECTION.deliveryInstructionCard,
  };

  const { chat_session_id, chat_dialogue_id, if_history, bot_id, intent_id } = trackingData;

  useEffect(() => {
    dispatchTrack({
      ...trackingParams, data: {
        chat_session_id,
        chat_dialogue_id,
        if_history,
        bot_id,
        intent_id,
      },
    });
  }, []);

  const customerElement = (
    <div className="delivery-instruction">
      <div className="delivery-instruction-title">{subTitle}</div>
      <div className="delivery-instruction-instructions">
        {instructions}
      </div>
    </div>
  );
  return (
    <div className="instruction-card">
      <ExpediteDeliveryCard title={title} customerElement={customerElement} />
    </div>
  );
};


export default DeliveryInstructionCard;
